import styled from "styled-components";

export const Text = styled.p`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  padding: 4px 0;
  color: #424248;
  word-break: break-all;
  word-wrap: break-word;

  &.arrow {
    min-width: 15px;
  }
  &.textAlteracao {
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StatusTag = styled.div`
  width: 100%;
  height: 24px;
  align-items: center;
  padding: 1px 16px;
  margin: 8px auto;
  border-radius: 16px;
`;

export const TagText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  padding-top: 2px;
  word-break: break-all;
  word-wrap: break-word;
`;

export const BodyAlteracao = styled.div`
  display: inline-flex;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  align-items: center;
  width: 100%;

  &.bodyObs {
    align-items: flex-start;

    .tagObs {
      display: flex;
      flex-wrap: wrap;

      .antes,
      .depois {
        width: 100%;
        text-overflow: unset;
        overflow: visible;
        white-space: break-spaces;
        min-width: auto;
        max-width: 100%;
        word-break: break-word;
      }

      .arrow {
        margin: 5px auto !important;
        transform: rotate(90deg);
      }
    }
  }
`;

export const BodyTarefas = styled.div`
  width: 100%;
`;

export const TagAlteracaoBody = styled.div`
  display: inline-flex;
  padding-bottom: 2px;
  align-items: center;
  width: calc(100% - 125px);
  .antes {
    background-color: #e8f9e8;
    color: #4caf50;
    border: 1px solid #4caf50;
    min-width: 23px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(60% - 7px);
  }
  .depois {
    background-color: rgba(244, 54, 54, 0.2);
    color: #f43636;
    border: 1px solid #f43636;
    min-width: 23px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(40% - 7px);
  }
`;

export const TagAlteracao = styled.p`
  padding: 2px 4px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin: auto 0;
  border-radius: 8px;
  word-break: break-all;
  word-wrap: break-word;
`;

export const TagEtapaBody = styled.div`
  display: inline-flex;
  .firstChild {
    width: 136px;
  }
`;

export const TagEtapa = styled.div`
  display: inline-flex;
  align-items: center;
  height: 26px;
  background-color: #ffffff;
  color: #424248;
  border-radius: 4px;
  border: 1px solid #ececec;
  padding: 4px 8px;
`;

export const FlexText = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
